<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="Confirm Order" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="body" v-if="store_final_total_list">
            <checkout-address class="address" v-on:onclick="goAddress" :item="store_final_total_list.address_info"></checkout-address>
            <div class="mt-5"></div>
            <!--付款方式-->
            <div @click="togglePay=true"><mt-cell class="menu-item" title="Payment method" ><span slot="icon" class="left-icon iconfont">&#xe664;</span>{{pay_name}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <div class="bank-transfer-panel" v-if="pay_code == 'offline' || pay_code == 'online'">
                <template v-if="pay_code == 'offline'">
                    <div class="panel-title">Please select a bank account for Bank Transfer:</div>
                    <div class="bank-list">
                        <div
                            class="bank-card"
                            v-for="bank in bank_options"
                            :key="bank.code"
                            :class="{ active: offline_bank_code == bank.code }"
                            @click="selectOfflineBank(bank)"
                        >
                            <div class="bank-title">{{bank.title}}</div>
                            <div class="bank-account">Account: {{bank.info.bank_account}}</div>
                        </div>
                    </div>
                </template>
                <div class="transfer-field" v-if="pay_code == 'offline'">
                    <label>PI NO.</label>
                    <input type="text" placeholder="e.g. Q-2-DQ-25-ROBERT0524" maxlength="40" v-model="pi_no">
                </div>
                <div class="form-row">
                    <div class="form-label">Incoterms</div>
                    <div class="incoterm-options">
                        <span
                            v-for="item in incoterm_options"
                            :key="item"
                            :class="{ active: incoterm_code == item }"
                            @click="incoterm_code = item"
                        >{{item}}</span>
                    </div>
                </div>
            </div>
            <!--发票-->
            <div @click="$router.push({name:'MemberInvoiceList',query:{isFromCheckout:true,goBackLevel:-1,invoice_id:invoice_id,vat_deny:store_final_total_list.vat_deny,params:JSON.stringify($route.query)}})"><mt-cell class="menu-item" title="Invoice" ><span slot="icon" class="left-icon iconfont">&#xe6f2;</span>{{invoice_content}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <checkout-store class="section-header" :storeTotal="store_final_total_list.store_total" :pay_code="pay_code" :initial_ratio="initial_ratio" :isSampleOrder="$route.query.is_sample == 1" :addressInfo="store_final_total_list.address_info" :payGoodsList="store_final_total_list.pay_goods_list" :finalTotalList="store_final_total_list.store_final_total_list" :addressApi="store_final_total_list.address_api" :storeCartList="store_final_total_list.store_cart_list" :ifshowOffpay="store_final_total_list.ifshow_offpay" @changeInitial2="changeInitial2" @selectVoucher="selectVoucher" @selectChain="selectChain" @changeMessage="changeMessage"></checkout-store>
        </div>
        <div class="bottom-wrapper" v-if="store_final_total_list">
            <mt-field v-if="!f_code_check && store_final_total_list.store_cart_list_api[0].goods_list[0].is_goodsfcode==1" label="F code" placeholder="Please fill in F code" type="text" v-model="f_code">
                <mt-button size="small" type="danger" @click="checkfcode">Use</mt-button>
            </mt-field>
            <div v-else class="amount-wrapper">
                <span class="amount ml-5" style="color: #fff">
<!--                    <label v-if="store_final_total_list && !hidePay">
                      <mt-switch v-model="pd_pay" v-if="store_final_total_list.available_predeposit>0">Pre-deposit（{{store_final_total_list.available_predeposit}}）</mt-switch><mt-switch v-model="rcb_pay" v-if="store_final_total_list.available_rc_balance>0">Recharge card（{{store_final_total_list.available_rc_balance}}|）</mt-switch>
                    </label>-->
                </span>
                <mt-button class="mr-5" size="small" type="danger" @click="checkout">Submit Order</mt-button>
            </div>
        </div>
        <mt-popup v-model="togglePay" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Payment method" class="common-header">
                    <mt-button slot="left" icon="back" @click="togglePay=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-radio
                    v-model="pay_code"
                    :options="pay_options">
                </mt-radio>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import { buyStep1, buyStep2, checkFCode, getChainList } from '../../../api/memberBuy'
import CheckoutAddress from './child/CheckoutAddress'
import CheckoutItem from './child/CheckoutItem'
import CheckoutStore from './child/CheckoutStore'

export default {
  name: 'Step1',
  components: {
    CheckoutAddress,
    CheckoutItem,
    CheckoutStore
  },
  data () {
    return {
      pay_name: 'Online payment',
      pay_code: 'online',
      pay_options: [{
        label: 'Online payment',
        value: 'online'
      }, {
        label: 'Bank transfer payment',
        value: 'offline'
      }],
      pay_list: { online: 'Online payment', offline: 'Bank transfer payment' },
      togglePay: false,
      hidePay: false,
      f_code: '',
      invoice_id: this.$route.query.invoice_id ? this.$route.query.invoice_id : 0,
      invoice_content: this.$route.query.invoice_content ? this.$route.query.invoice_content : '',
      f_code_check: false,
      cart_id: this.$route.query.cart_id ? this.$route.query.cart_id : '',
      store_final_total_list: null,
      // store_total: [],
      initial_ratio: this.$route.query.is_sample ? '100' : '10',
      pd_pay: false,
      rcb_pay: false,
      password: '',
      message: [],
      chain_goods: {},
      offline_bank_code: '',
      offline_bank_info: '',
      pi_no: '',
      incoterm_code: '',
      bank_options: [
        {
          code: 'dahsing_hkd',
          title: 'Dah Sing Bank, Limited (Hong Kong)',
          info: {
            account_holder_name: 'QANA HOLDINGS GROUP CO.,LIMITED',
            account_holder_address: '31F Block B Lechuanghui Building, 1211. Guanguang Road, Longhua District, Shenzhen, Guangdong, China',
            bank_account: '77439079586',
            bank_name: 'Dah Sing Bank, Limited',
            bank_address: 'Everbright Centre, 108 Gloucester Road, Wanchai, HongKong',
            swift_code: 'DSBAHKHH',
            bank_code: '040',
            branch_code: '774'
          }
        },
        {
          code: 'icbc_usd',
          title: 'ICBC (Shenzhen Branch) - USD',
          info: {
            account_holder_name: 'QANA INNOVATION CO., LTD',
            account_holder_address: '31F Block B Lechuanghui Building, 1211. Guanguang Road, Longhua District, Shenzhen, Guangdong, China',
            bank_account: '4000103819100092345',
            bank_name: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA(SHENZHEN BRANCH)',
            bank_address: 'CLEARING CENTRE 2/F NORTH BLOCK FIANCIAL CENTRE SHENNAN ROAD EAST SHENZHEN P.R.CHINA',
            swift_code: 'ICBKCNBJSZN'
          }
        }
      ],
      incoterm_options: ['EXW', 'FCA', 'FAS', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DPU', 'DAP', 'DDP']
    }
  },
  watch: {
    pay_code: function (pay_code) {
      this.pay_name = this.pay_list[pay_code]
      this.togglePay = false
      if (pay_code == 'offline' && this.store_final_total_list && !this.store_final_total_list.pay_goods_list.online) {
        this.hidePay = true
      } else {
        this.hidePay = false
      }
      if (pay_code == 'offline' && this.$route.query.is_sample) {
        this.initial_ratio = '100'
      }
    }
  },
  created: function () {
    this.getBuyInfo()
  },
  methods: {
    checkfcode () {
      checkFCode(this.store_final_total_list.store_cart_list_api[0].goods_list[0].goods_commonid, this.f_code).then(res => {
        this.f_code_check = true
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 获取订单信息
    getBuyInfo () {
      let extra = {}
      if (this.$route.query.bargainorder_id) {
        extra['bargainorder_id'] = this.$route.query.bargainorder_id
      }
      if (this.$route.query.is_sample) {
        extra['is_sample'] = 1
      }
      if (this.$route.query.warehouse_id) {
        extra['warehouse_id'] = this.$route.query.warehouse_id
      }
      buyStep1(
        this.cart_id, this.$route.query.buy_now ? 0 : 1, this.$route.query.pintuan_id, this.$route.query.pintuangroup_id, extra
      ).then((res) => {
        if (res.code === 10000) {
          // console.log(res);
          this.store_final_total_list = res.result
          this.$set(this.store_final_total_list.store_total, 'order_amount', parseFloat(this.store_final_total_list.order_amount || 0))
          if (this.invoice_content) {
            if (!this.store_final_total_list.inv_info.invoice_id) {
              this.invoice_id = 0
              this.invoice_content = this.store_final_total_list.inv_info.invoice_title
            }
          } else {
            this.invoice_content = this.store_final_total_list.inv_info.invoice_title
            if (this.store_final_total_list.inv_info.invoice_id) {
              this.invoice_id = this.store_final_total_list.inv_info.invoice_id
            }
          }
          // console.log(res.result)
        } else {

        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goBack () {
      this.$router.go(-1)
    },
    selectVoucher (voucherInfo, store_id) {
      this.store_final_total_list.store_cart_list[store_id].store_voucher_info = voucherInfo
    },
    selectChain (chain, goods) {
      this.chain_goods[goods.bl_id + '_' + goods.goods_id] = chain.chain_id
    },
    changeInitial2 (initialRatio) {
      this.initial_ratio = initialRatio
    },
    goAddress () {
      if (this.store_final_total_list.address_info) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.$router.push({
          name: 'MemberAddressForm',
          query: {
            action: 'add',
            isFromCheckout: true,
            goBackLevel: -1
          }
        })
      }
    },
    changeMessage (message, store_id) {
      this.message[store_id] = message
    },
    selectOfflineBank (bank) {
      this.offline_bank_code = bank.code
      this.offline_bank_info = JSON.stringify(bank.info)
    },
    validatePaymentDetails () {
      if (this.pay_code === 'offline' && !this.offline_bank_code) {
        Toast('Please select a bank account')
        return false
      }
      if (this.pay_code === 'offline') {
        var piNo = this.pi_no.replace(/^\s+|\s+$/g, '')
        if (piNo && !/^[A-Za-z0-9-]{5,40}$/.test(piNo)) {
          Toast('PI NO. must be 5-40 characters, letters, numbers and hyphens only')
          return false
        }
      }
      if (!this.incoterm_code) {
        Toast('Please select an Incoterm')
        return false
      }
      return true
    },
    // 提交订单
    checkout () {
      let ifcart = this.$route.query.buy_now ? 0 : 1
      let pintuan_id = this.$route.query.pintuan_id
      let pintuangroup_id = this.$route.query.pintuangroup_id
      let cart_id = this.cart_id
      let address_id = this.store_final_total_list.address_info ? this.store_final_total_list.address_info.address_id : 0
      let vat_hash = this.store_final_total_list.vat_hash
      let offpay_hash = this.store_final_total_list.address_api.offpay_hash
      let offpay_hash_batch = this.store_final_total_list.address_api.offpay_hash_batch
      let invoice_id = this.invoice_id
      let voucher = null
      let pd_pay = (!this.hidePay && this.pd_pay) ? 1 : 0
      let password = this.password
      let rcb_pay = (!this.hidePay && this.rcb_pay) ? 1 : 0
      let pay_message_temp = []
      let payment_type = this.pay_code
      let initial_ratio = this.initial_ratio ? this.initial_ratio : 10
      let f_code = this.f_code
      let pay_code = this.pay_code
      if (!address_id) {
        MessageBox.alert('You need to add the shipping address first', '')
        return
      }
      if (!this.validatePaymentDetails()) {
        return
      }
      if (!this.hidePay && (pd_pay || rcb_pay)) {
        if (!this.store_final_total_list.member_paypwd) {
          MessageBox.confirm(
            'You need to set up a payment password first',
            'Tip',
            {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel'
            }
          ).then(action => {
            this.$router.push({ name: 'MemberSetting' })
          })
          return
        } else {
          if (!password) {
            MessageBox.prompt('<b>Please enter payment password</b><br/>Note: The default payment password is: 123456', '', {
              showCancelButton: true,
              inputType: 'password'
            }).then(({ value, action }) => {
              this.password = value
              this.checkout()
            })
            return
          }
        }
      }
      // 处理格式
      voucher = ''
      let voucher_temp = []
      for (var t in this.store_final_total_list.store_cart_list) {
        var voucherInfo = this.store_final_total_list.store_cart_list[t].store_voucher_info || {}
        voucher_temp.push([(voucherInfo.vouchertemplate_id || '') + '|' + t + '|' + (voucherInfo.voucher_price || 0)])
      }
      voucher = voucher_temp.join(',')
      let i
      for (i in this.store_final_total_list.store_cart_list) {
        let message = this.message[this.store_final_total_list.store_cart_list[i].store_id]
        if (typeof (message) === 'undefined') {
          message = ''
        }
        pay_message_temp.push(this.store_final_total_list.store_cart_list[i].store_id + '|' + message)
      }
      let pay_message = pay_message_temp.join(',')
      let extra = {}
      if (this.$route.query.bargainorder_id) {
        extra['bargainorder_id'] = this.$route.query.bargainorder_id
      }
      if (this.$route.query.is_sample) {
        extra['is_sample'] = 1
      }
      if (this.$route.query.warehouse_id) {
        extra['warehouse_id'] = this.$route.query.warehouse_id
      }
      if (pay_code == 'offline') {
        extra['offline_bank_code'] = this.offline_bank_code
        extra['offline_bank_info'] = this.offline_bank_info
        extra['pi_no'] = this.pi_no.replace(/^\s+|\s+$/g, '')
      }
      extra['incoterm_code'] = this.incoterm_code
      extra['incoterm_place'] = ''
      extra['chain_goods'] = this.chain_goods
      buyStep2(
        ifcart,
        cart_id,
        address_id,
        vat_hash,
        offpay_hash,
        offpay_hash_batch,
        invoice_id,
        voucher,
        pd_pay,
        password,
        rcb_pay,
        payment_type,
        initial_ratio,
        pay_message,
        pintuan_id,
        pintuangroup_id,
        f_code,
        pay_code,
        extra
      ).then((res) => {
        // 跳转到支付界面
        let pay_sn = res.result.pay_sn
        if (pay_code == 'offline') {
          this.$router.push({ name: 'MemberBuyPayOffline', query: { pay_sn: pay_sn } })
        } else {
          this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: pay_sn, pay_type: 'pay_new' } })
        }
      }).catch(error => {
        this.password = ''
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }
    .header {
        height: 2.2rem;
        color: #48505d;
        font-size: 0.9rem;
        background-color: #fff;
        padding: 0.1rem 0;
        border-bottom: 1px solid #e8eaed;
    }
    .body {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        margin-bottom:3rem;
    }
    .address {
        height: 5rem;
    }
    .goods {
        height: 4.5rem;
    }
    .item {
        height: 2.5rem;
    }
    .section-header {
        margin-top: 0.4rem;
    }
    .bank-transfer-panel {
        margin-top: 0.4rem;
        padding: 0.65rem 0.75rem 0.7rem;
        background: #fff;
        border-top: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
    }
    .panel-title {
        margin-bottom: 0.45rem;
        color: #333;
        font-size: 0.62rem;
        font-weight: bold;
        line-height: 0.9rem;
    }
    .bank-list {
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        margin-bottom: 0.55rem;
    }
    .bank-card {
        position: relative;
        padding: 0.48rem 0.6rem 0.48rem 0.75rem;
        border: 1px solid #ddd;
        border-radius: 0.18rem;
        background: #fff;
    }
    .bank-card.active {
        border-color: #e93b3d;
        background: #fff7f7;
    }
    .bank-card.active:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.45rem;
        bottom: 0.45rem;
        width: 0.12rem;
        background: #e93b3d;
    }
    .bank-title {
        color: #333;
        font-size: 0.62rem;
        font-weight: bold;
        line-height: 0.85rem;
    }
    .bank-account {
        margin-top: 0.18rem;
        color: #777;
        font-size: 0.55rem;
        line-height: 0.75rem;
    }
    .transfer-field {
        padding: 0.5rem 0;
        border-top: 1px solid #f2f2f2;
    }
    .transfer-field label {
        display: block;
        margin-bottom: 0.3rem;
        color: #333;
        font-size: 0.62rem;
        line-height: 0.8rem;
    }
    .transfer-field input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        padding: 0 0.5rem;
        border: 1px solid #ddd;
        border-radius: 0.15rem;
        color: #333;
        font-size: 0.62rem;
        background: #fff;
    }
    .transfer-field input::placeholder {
        color: #999;
    }
    .form-row {
        padding: 0.5rem 0;
        border-top: 1px solid #f2f2f2;
    }
    .form-label {
        margin-bottom: 0.35rem;
        color: #333;
        font-size: 0.62rem;
        line-height: 0.8rem;
    }
    .incoterm-options {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 0.35rem;
    }
    .incoterm-options span {
        box-sizing: border-box;
        width: 100%;
        height: 1.45rem;
        padding: 0 0.35rem;
        border: 1px solid #ddd;
        border-radius: 0.15rem;
        color: #555;
        font-size: 0.6rem;
        line-height: 1.45rem;
        text-align: center;
        background: #fff;
    }
    .incoterm-options span.active {
        border-color: #e93b3d;
        color: #fff;
        background: #e93b3d;
    }
    .section-footer {
        margin-bottom: 0.4rem;
    }
    .comment {
        height: 7.25rem;
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .desc-item {
        height: 1.5rem;
    }
    .bottom-wrapper {
        z-index: 1;
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        min-height: 2.5rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        border-top: 1px solid #f2f2f2;
    }
    .amount-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
    }
    .amount {
        flex: 1;
        font-size: 0.8rem;
        color: $primaryColor;
        text-align: right;
        padding-right: 0.75rem;
    }
    .submit {
        width: 7.5rem;
        height: 2.5rem;
        border-radius: 0;
    }
    .left-icon{float:left;font-size:0.9rem;margin-right:0.2rem;}
</style>
